import AppRecord from './AppRecord.js'

class Person extends AppRecord {
  // Consider setting name_type concatenationf ro imporved selection
  // setNameType(){
  //   Vue.set(this, 'name_type', this.name + ' - ' + {'Client': 'Kunde', 'Administrator': 'Administrator', 'Employee':'Kollega', 'BankContact': 'Bank kontakt'}[this.type])
  // }
  get controller_name(){
    return 'PeopleController'
  }
  get age(){
    if(this.birthday){
      let today = new Date
      let desc = Date.parse(this.deceased)
      let date = Math.min(...[today.getTime(), desc].filter(v => v))
      let diff = date - Date.parse(this.birthday)
      let ageDate = new Date(diff)
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    } else {
      return null
    }
  }
  get user(){
    return this.constructor.employeeStore.usersByPersonId.get(this.id)
  }
  set user(usr){
    if(usr){
      this.setRelatedData([usr],'UsersController')
    }
  }

  get hasUser(){
    return !!this.user
  }

  get ownerships(){
    return this.constructor.employeeStore.ownershipsByPersonId.get(this.id) ?? []
  }
  get entities(){
    const entitiesById = this.constructor.employeeStore.entitiesById
    return this.ownerships.map(own => entitiesById.get(own.entity_id)).filter(Boolean)
  }
  get contact_informations(){
    return this.constructor.employeeStore.personContactInformationsById.get(this.id) ?? []
  }
  get accounts(){
    return this.entities.map(ent => ent.accounts).flat()
  }
  get deposits(){
    return this.entities.map(ent => ent.deposits).flat()
  }
  get meeting_summaries(){
    return this.constructor.employeeStore.meeting_summaries.filter(ms=> ms.participant_ids.includes(this.id))
  }
  get email_object(){
    return this.contact_informations.find(ci => ci.type === 'Email')
  }
  get email(){
    return (this.email_object||{}).info
  }
  get phone_object(){
    return this.contact_informations.find(ci => ci.type === 'PhoneNumber')
  }
  get phone_number(){
    return (this.phone_object||{}).info
  }
  get address_object(){
    return this.contact_informations.find(ci => ci.type === 'Address')
  }
  get address(){
    return (this.address_object||{}).info
  }
  set entities(items){
    this.setRelatedData(items, 'EntitiesController')
  }
  set contact_informations(items){
    this.setRelatedData(items, 'ContactInformationsController')
  }
  set accounts(items){
    this.setRelatedData(items, 'AccountsController')
  }
  set deposits(items){
    this.setRelatedData(items, 'DepositsController')
  }
  set meeting_summaries(items){
    this.setRelatedData(items, 'MeetingSummariesController')
  }

  get form_cpr(){
    return this.cpr
  }
  set form_cpr(newCpr) {
    if (newCpr != null && newCpr.length === 10) {
      let d = newCpr.substr(0, 2);
      let m = newCpr.substr(2, 2);
      let y = parseInt(newCpr.substr(4, 2));

      let tdYear = ('' + new Date().getFullYear()).substr(2);  new Date()

      if (y > tdYear) y+= 1900; else y+= 2000;

      const dateString = y.toString() + '-' + ('0' + m.toString()).slice(-2) + '-' + ('0' + d.toString()).slice(-2);

      let validDate = Date.parse(dateString);

      if (!isNaN(validDate)) {
        this.birthday = dateString;
      }
    }
    this.cpr = newCpr
  }

  get bottom_entities(){
    return this.entities.filter(ent => ent.descendant_ids.length === 0)
  }
  get value_ytd(){
    if(this._value_ytd){return this._value_ytd}
    let value = this.bottom_entities.reduce((sum, ent) => sum + ent.value_ytd, 0)
    Vue.set(this, '_value_ytd', value)
    return value
  }
  get ret_ytd(){
    if(this._ret_ytd){return this._ret_ytd}
    let value = this.bottom_entities.reduce((sum, ent) => sum + ent.ret_ytd, 0)
    Vue.set(this, '_ret_ytd', value)
    return value
  }
  get rpct_ytd(){
    if(this._rpct_ytd){return this._rpct_ytd}
    var base
    var sum = 0
    var sum_prod = 0
    this.bottom_entities.forEach((ent) => {
      if(ent.rpct_ytd && ent.rpct_ytd != 0){
        base = Math.abs(ent.ret_ytd/ent.rpct_ytd)
        sum += base
        sum_prod += base*ent.rpct_ytd
      }
    })
    let value = (sum_prod / sum) || 0
    Vue.set(this, '_rpct_ytd', value)
    return value
  }
  get value_prev(){
    if(this._value_prev){return this._value_prev}
    let value = this.bottom_entities.reduce((sum, ent) => sum + ent.value_prev, 0)
    Vue.set(this, '_value_prev', value)
    return value
  }
  get ret_prev(){
    if(this._ret_prev){return this._ret_prev}
    let value = this.bottom_entities.reduce((sum, ent) => sum + ent.ret_prev, 0)
    Vue.set(this, '_ret_prev', value)
    return value
  }
  get rpct_prev(){
    if(this._rpct_prev){return this._rpct_prev}
    var base
    var sum = 0
    var sum_prod = 0
    this.bottom_entities.forEach((ent) => {
      if(ent.rpct_prev && ent.rpct_prev != 0){
        base = Math.abs(ent.ret_prev/ent.rpct_prev)
        sum += base
        sum_prod += base*ent.rpct_prev
      }
    })
    let value = (sum_prod / sum) || 0
    Vue.set(this, '_rpct_prev', value)
    return value
  }
  get link(){
    let resolve = {
      'Client': 'clients',
      'BankContact': 'bank_contacts',
      'Administrator': 'administrators',
      'Employee': 'employees',
      'Person': 'people',
    }[this.type]
    return {
      name: resolve,
      id: this.id,
      path: `/employee/crm/${resolve}/${this.id}`
    }
  }

  get translated_type(){
    return {
        'Client': 'Kunde',
        'Employee': 'Kollega',
        'BankContact': 'Bank kontakt',
        'Administrator': 'Administrator',
      }[this.type]
  }

  get risk_assessments(){
    return this.constructor.employeeStore.riskAssessmentsByPersonId.get(this.id) ?? []
  }
  set risk_assessments(items){
    this.setRelatedData(items, 'RiskAssessmentsController')
  }
  get current_risk_assessment(){
    return [...this.risk_assessments].sortBy('from').reverse()[0]
  }
  get person_consultants(){
    // most recent and primaries first — backend sorts for us
    return this.constructor.employeeStore.personConsultantsByPersonId.get(this.id) ?? []
  }
  get primary_person_consultants(){
    return this.person_consultants.filter(rel => rel.relation_type == 'primary')
  }  
  get primary_consultant(){
    const rel = this.person_consultants.find(rel => rel.relation_type === 'primary')
    return rel ? (this.constructor.employeeStore.peopleById.get(rel.consultant_id) ?? null) : null
  }
  get secondary_consultant(){
    const rel = this.person_consultants.find(rel => rel.relation_type === 'secondary')
    return rel ? (this.constructor.employeeStore.peopleById.get(rel.consultant_id) ?? null) : null
  }
  get external_consultant(){
    const rel = this.person_consultants.find(rel => rel.relation_type === 'external')
    return rel ? (this.constructor.employeeStore.peopleById.get(rel.consultant_id) ?? null) : null
  }
  get current_primary_relations(){
    return this.primary_person_consultants.filter(rel => (rel.person.primary_consultant||{}).id === this.id)
  }
}


export default Person
